<template>
  <article class="CscHome">
    <section class="CscHome-Section">
      <banner-call-to-action
        message="A busca permanente pela excelência é nosso compromisso!"
        slogan="&ldquo;Seu sucesso é nossa missão.&rdquo;"
        class="CscHome-BannerCallToAction"
        @click="openServices()"
      />
    </section>

    <section class="CscHome-Section">
      <the-title
        class="CscHome-Title"
      >Cursos e Desenvolvimento</the-title>

      <training-call-to-action
        @click="openTrainings()"
      />
    </section>

    <section class="CscHome-Section">
      <banner-call-to-action-woman
        message="Saiba quais concursos e processos seletivos estão acontecendo."
        class="CscHome-BannerCallToAction"
        @click="openOngoingEvents()"
      />
    </section>

    <section class="CscHome-Section">
      <the-title
        class="CscHome-Title"
      >Contato</the-title>

      <contact-block
        @alert="handleAlert"
      />
    </section>
  </article>
</template>

<style lang="scss" scoped>
  @import "~@/styles/_variables.scss";

  .CscHome {
    background-color: $color-background-white;
    background-size: 10px 10px;
    background-image: repeating-linear-gradient(45deg, $background-pattern-gray 0, $background-pattern-gray 1px, $color-background-white 0, $color-background-white 50%);

    &-Title {
      margin: 15px 20px;
    }
  }
</style>

<script>
  import BannerCallToAction from "@/components/BannerCallToAction";
  import BannerCallToActionWoman from "@/components/BannerCallToActionWoman";
  import ContactBlock from "@/components/ContactBlock";
  import TheTitle from "@/components/TheTitle";
  import TrainingCallToAction from '@/components/TrainingCallToAction.vue';

  export default {
    name: "CscHome",

    components: {
      BannerCallToAction,
      BannerCallToActionWoman,
      ContactBlock,
      TheTitle,
      TrainingCallToAction,
    },

    methods: {
      openServices() {
        this.$router.push({ path: "/servicos" }).catch(() => {});
      },

      openTrainings() {
        this.$router.push({ path: "/treinamentos-e-desenvolvimento-profissional" }).catch(() => {});
      },

      openOngoingEvents() {
        window.open("https://csc.selecao.net.br/", "_blank", "noopener,noreferrer");
      },

      openCandidateArea() {
        window.open("https://csc.selecao.net.br/login/?redir=&login=", "_blank", "noopener,noreferrer");
      },

      handleAlert(event) {
        this.$emit("alert", event);
      },
    },
  };
</script>
